import { isRouteErrorResponse, useRouteError } from "react-router-dom";

import { Button } from "@/components/ui/Button";

export const ErrorPage = () => {
    const error = useRouteError();
    const isKnownError = isRouteErrorResponse(error);

    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-slate-100 px-6 text-center text-slate-700 dark:bg-slate-950 dark:text-slate-200">
            <h1 className="text-4xl font-semibold text-slate-900 dark:text-slate-50">Something went wrong</h1>
            <p className="mt-4 max-w-lg text-sm text-slate-500 dark:text-slate-300">
                {isKnownError
                    ? `${error.status} — ${error.statusText}`
                    : "An unexpected error occurred. Please try again later or contact support."}
            </p>
            <div className="mt-8">
                <Button onClick={() => window.location.assign("/")}>Back to dashboard</Button>
            </div>
        </div>
    );
};

